import { Box } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import BarChartIcon from '@mui/icons-material/BarChart';
import FitScreenIcon from '@mui/icons-material/FitScreen';
import SyncIcon from '@mui/icons-material/Sync';
import { useCallback } from 'react';
import { useWidget } from '../widget.hook';
import { useSymbolFeedContext } from './symbol-feed.context';
import { AppIconButton } from '@client/foundation/design-system/components';
import { emitFitContent } from '../../events';
import {
  getChartSyncEnabled$,
  setChartSyncEnabled
} from '../chart/services/chart-sync-toggle.service';
import { useObservable } from '@client/foundation/shared/utils/observable.hook';
import { getWorkspaceFullscreen$ } from './workspace-fullscreen.service';

export const SymbolLayoutToolbar = () => {
  const { tradingStats$, chartId, state } = useSymbolFeedContext();
  const { openWidget } = useWidget();
  const chartSyncEnabled = useObservable(getChartSyncEnabled$);
  const tradingStats = useObservable(() => tradingStats$, undefined);
  const workspaceFullscreen = useObservable(() => getWorkspaceFullscreen$());

  const handleOpenTradingForm = useCallback(() => {
    const mode = state?.marketConfig?.tradingMode;
    if (!mode) return;

    openWidget({
      type: 'TradingForm',
      id: chartId,
      mode,
      initSource: 'LAYOUT_RESTORE'
    });
  }, [openWidget, chartId, state?.marketConfig?.tradingMode]);

  const handleOpenTradingStats = useCallback(() => {
    if (!tradingStats) return;

    openWidget({ type: 'Stats', data: tradingStats });
  }, [openWidget, tradingStats]);

  const handleFitContent = useCallback(() => {
    emitFitContent();
  }, []);

  const handleToggleChartSync = useCallback(() => {
    setChartSyncEnabled(!chartSyncEnabled);
  }, [chartSyncEnabled]);

  if (workspaceFullscreen) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: 0.75
      }}
    >
      <AppIconButton
        title="Settings"
        tone="primary"
        onClick={handleOpenTradingForm}
      >
        <SettingsIcon />
      </AppIconButton>

      <AppIconButton
        title="Results"
        tone="primary"
        onClick={handleOpenTradingStats}
      >
        <BarChartIcon />
      </AppIconButton>

      <AppIconButton
        title="Fit Content"
        tone="primary"
        onClick={handleFitContent}
      >
        <FitScreenIcon />
      </AppIconButton>

      <AppIconButton
        title={chartSyncEnabled ? 'Disable chart sync' : 'Enable chart sync'}
        tone={chartSyncEnabled ? 'primary' : 'ghost'}
        onClick={handleToggleChartSync}
      >
        <SyncIcon />
      </AppIconButton>
    </Box>
  );
};
